import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCrosshairs, faGasPump, faLocationDot, faGift } from '@fortawesome/free-solid-svg-icons'

library.add(faCrosshairs)
library.add(faGasPump)
library.add(faLocationDot)
library.add(faGift)

export { FontAwesomeIcon }